// @ts-nocheck
// import { ButtonPresentationProps } from "@insite/mobius/Button"; // Foundation
import { IconPresentationProps } from "@insite/mobius/Icon";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import {
    buttonFieldIconClickableStyles,
    buttonFieldIconStyles,
    buttonResetStyles,
} from "@store/Themes/common/mixins/button";
import { ButtonVariant } from "@toolkit/Framework/Types/Button";

/* Foundation - Start */
import { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import ShoppingBagFill, {
    ShoppingBagFillOffset,
} from "@store/Library/Components/Toolkit/Icons/ShoppingBag/ShoppingBagFill";
import { checkoutButtonsStyles } from "@store/Themes/common/mixins/button";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";
/* Foundation - End */

// Store Custom Code
import Lock from "@insite/mobius/Icons/Lock";

export const buttonResetProps: ButtonPresentationProps = {
    color: null as any,
    buttonType: null as any,
    shape: null as any,
    hoverMode: "none",
    activeMode: "none",
    css: buttonResetStyles(false),
};

export const buttonGetFieldIconProps = (
    src: IconPresentationProps["src"],
    variant?: ButtonVariant,
): TextFieldPresentationProps => ({
    iconProps: {
        src,
        css: buttonFieldIconStyles(),
    },
    iconClickableProps: {
        css: buttonFieldIconClickableStyles(variant),
    },
});

/* Foundation - Start */
export const buttonGetHoverProps = (color: string): ButtonPresentationProps => ({
    hoverStyle: { color },
    activeStyle: { color },
});

export const checkoutButtonsProps: ButtonPresentationProps = {
    /* Store Custom Code */
    size: 50,
    icon: {
        /* Store Custom Code */
        src: Lock,
        position: "left",
    },
    css: css`
        ${checkoutButtonsStyles()}
    `,
};

export const productDetailButton: ButtonPresentationProps = {
    sizeVariant: "large",
    typographyProps: {
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: ${({ theme }) => theme.design.typography.size.base};
                        `,
                        null,
                        null,
                        css`
                            font-size: ${({ theme }) => theme.design.typography.size.larger};
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    css: css`
        ${({ theme }) => theme.button.primary.css}
        display: flex;
        align-items: center;

        ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        min-width: ${pxToRem(180)};
                        padding: 0 ${pxToRem(15)};
                    `,
                    css`
                        padding: 0 ${pxToRem(30)};
                    `,
                    css`
                        min-width: ${pxToRem(220)};
                    `,
                ],
                mediaOptions.min,
            )}

        ${ButtonIcon} {
            top: 0;
            width: ${pxToRem(24)};

            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-right: 1em;
                        `,
                        null,
                        null,
                        css`
                            margin-right: 1.5em;
                        `,
                    ],
                    mediaOptions.min,
                )}
        }
    `,
};

export const carouselButtonStyle = (side: "right" | "left"): ButtonPresentationProps => ({
    variant: "primary",
    css: css`
        flex-shrink: 0;
        width: ${pxToRem(50)};
        height: ${pxToRem(50)};
        border: 0;
        border-radius: 50%;
        padding: 0;

        ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css``,
                    css`
                        position: absolute;
                        ${side}: 0.75em;
                    `,
                    css`
                        position: absolute;
                        ${side}: -0.625rem;
                    `,
                    css``,
                    css``,
                ],
                mediaOptions.min,
            )}
    `,
});
/* Foundation - End */
